import classes from './fieldByType.module.css';

import { address_server_short, PUBLIC_ASSETS } from '../../../config';
import classNames from 'classnames';

const ImageTypeField = ({ forTable, params, item }) => {
  const imageUrl = `${address_server_short}${PUBLIC_ASSETS}${item}`;
  return Array.isArray(params) ? (
    params?.map((imagePath, index) => {
      return (
        <img
          key={index}
          src={address_server_short + imagePath}
          alt={'img'}
          className={classes.image}
        />
      );
    })
  ) : forTable && item ? (
    <div className={classNames(classes.containerImgSize, classes.imageContainer)}>
      <img src={imageUrl} className={classNames(classes.itemImg)} alt="N/A" />
    </div>
  ) : (
    ''
  );
};

export default ImageTypeField;
